import { Card } from "@heroui/card";
import { Loader2 } from "lucide-react";

interface TaskLoadingProps {
  message?: string;
}

export function TaskLoading({ message = "Loading..." }: TaskLoadingProps) {
  return (
    <Card className="p-6 bg-white shadow-lg border-2 border-swapper-primary/20 rounded-2xl w-full">
      <div className="flex flex-col items-center justify-center space-y-4 py-8">
        <Loader2 className="h-8 w-8 animate-spin text-swapper-primary" />
        <p className="text-sm text-swapper-secondary/70">{message}</p>
      </div>
    </Card>
  );
}
